import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  },

  profileMenu: {
    minWidth: 96,
  }
}));